<div class="badge">
  <span class="billable" *ngIf="isBillable$ | async">{{
    "workorder.badge.billable" | translate
  }}</span>
  <span class="non-billable" *ngIf="isNonBillable$ | async">{{
    "workorder.badge.non-billable" | translate
  }}</span>
  <span class="mandatory" *ngIf="isMandatory$ | async">{{
    "workorder.badge.mandatory" | translate
  }}</span>
</div>
